export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.modal();
    }

    modal(resetOption) {
        const opengallerybuttons = [...document.querySelectorAll(".js-gallerymodal_open")];
        const closegallerybuttons = [...document.querySelectorAll(".js-gallerymodal_close")];
        const modals = [...document.querySelectorAll(".js-modal")];

        const handleGalleryOpen = (e) => {
            e.preventDefault();
            const modalID = e.currentTarget.getAttribute("data-modalID");
            const prevbtn = document.querySelector(".m-gallery__switch__btn.-prev");
            const nextbtn = document.querySelector(".m-gallery__switch__btn.-next");
            const tgtmodal = document.querySelector(`.js-modal[data-modalID=${modalID}]`);

            const jsonData = require("../../../_inc/parts/gallery/gallerylist.json"); //←importでやるといいよ

            //切り替えボタン
            const modalphindex = e.currentTarget.getAttribute("data-index");

            const currentindex = jsonData[modalphindex];
            const phnum = currentindex.id;
            const phpath = `/assets/img/gallery/ph_${phnum}.jpg`;

            const phcont = document.querySelector(".js-galleryph");
            const phttlcont = document.querySelector(".js-galleryphttl");
            const phttl = currentindex.name;

            phcont.setAttribute("src", ""); // 初期化
            phcont.setAttribute("src", phpath);
            phttlcont.textContent = phttl;

            prevbtn.setAttribute("data-index", ""); // 初期化
            nextbtn.setAttribute("data-index", ""); // 初期化

            var indexnum = Number(modalphindex);
            var previndex = indexnum - 1;
            var nextindex = indexnum + 1;

            if (previndex === -1) {
                previndex = 12;
                prevbtn.setAttribute("data-index", previndex);
            }
            if (nextindex === 13) {
                nextindex = 0;
                nextbtn.setAttribute("data-index", nextindex);
            }

            prevbtn.setAttribute("data-index", previndex);
            nextbtn.setAttribute("data-index", nextindex);

            document.body.classList.add("-lock");
            tgtmodal && tgtmodal.classList.add("-active");
        };

        const handleGalleryClose = (e) => {
            document.body.classList.remove("-lock");
            modals.forEach((el) => el.classList.remove("-active"));
        };

        opengallerybuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleGalleryOpen);
            el.addEventListener("click", handleGalleryOpen);
        });

        closegallerybuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleGalleryClose);
            el.addEventListener("click", handleGalleryClose);
        });
    }
}
